var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path === '/exhibition')?[_c('newHeader'),_vm._v(" "),_c('div',{attrs:{"id":"container"}},[_c('router-view')],1),_vm._v(" "),_c('ExhibitionFooter'),_vm._v(" "),_c('GoTop')]:[_c('newHeader'),_vm._v(" "),_c('div',{attrs:{"id":"container"}},[_c('router-view')],1),_vm._v(" "),_c('Footer')]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e8d6bb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 